export const setDataForGithubInLocalStorage = (userId: string | undefined, callbackPage: string) => {
	const data = {
		userId: userId || '',
		isForGitHubConnect: true,
		callbackPage,
	};
	// set data into localstorage
	localStorage.setItem('githubConnect', JSON.stringify(data));
};

export const setDataForLinkedInLocalStorage = (userId: string | undefined, callbackPage: string) => {
	const data = {
		userId: userId || '',
		isForLinkedInConnect: true,
		callbackPage,
	};
	// set data into localstorage
	localStorage.setItem('linkedInConnect', JSON.stringify(data));
};
